// Dictionnaire i18n PROGÈRE — FR (défaut) + EN
export const TRANSLATIONS = {
  fr: {
    nav: { modules: "Modules", pricing: "Tarification", ecosystem: "Écosystème", plans: "Forfaits", demo: "Démo", space: "Accéder à mon espace", mySpace: "Mon espace" },
    hero: {
      badge: "Portail officiel",
      title2a: "Toute votre entreprise de construction,",
      title2b: "pilotée d'un seul endroit.",
      desc: "Punch, CRM, projets, comptabilité, devis IA — fini les logiciels dispersés. PROGÈRE connecte vos chantiers, vos équipes et votre administration dans un écosystème intelligent, pensé pour le Québec.",
      ctaSpace: "Accéder à mon espace",
      ctaModules: "Voir les modules",
      ctaDemo: "Demander une démo",
      stat1: "Modules connectés", stat2: "Connexion unique (SSO)", stat3: "Utilisateurs (Entreprise)",
    },
    trust: {
      loi25: "Conforme Loi 25", loi25s: "Protection des données (QC)",
      tax: "TPS / TVQ", taxs: "Taxes québécoises intégrées",
      canada: "Hébergé au Canada", canadas: "Données en sol canadien",
      support: "Support en français", supports: "Une équipe d'ici, incluse",
    },
    ba: {
      eyebrow: "Le problème → la solution",
      titleA: "Arrêtez de jongler avec", titleB: "6 logiciels séparés",
      desc: "Un seul cerveau pour tout le chantier. PROGÈRE réunit ce qui était éparpillé dans un système où tout se parle.",
      before: "Avant", withP: "Avec",
      chaos: ["Excel de paie", "Emails de devis", "App de pointage", "Feuilles papier", "Dossiers perdus", "Impressions"],
      beforeText: "Données dispersées, doubles saisies, informations perdues. Vos équipes perdent du temps à recopier au lieu de bâtir.",
      afterText: "Une seule connexion, une seule base de données. Vos chantiers, clients, employés et finances synchronisés en temps réel.",
      cta: "Construire mon système",
    },
    modules: {
      eyebrow: "L'écosystème", titleA: "Tous vos modules,", titleB: "un seul portail",
      desc: "Chaque module PROGÈRE est spécialisé et parfaitement connecté au portail central. Cliquez pour accéder directement.",
      discover: "Découvrir & voir les prix", supportCta: "Besoin de support ? Cliquez ici",
    },
    eco: {
      eyebrow: "Écosystème centralisé", titleA: "Tout est connecté à",
      desc: "PROGÈRE est l'application maîtresse. Elle centralise vos entreprises, utilisateurs, rôles et permissions — et branche chaque module de l'écosystème sur une seule plateforme cohérente.",
      p1t: "API centrale", p1: "Tous les modules communiquent via l'API centrale PROGÈRE.",
      p2t: "Single Sign-On", p2: "Une seule connexion pour accéder à tout l'écosystème.",
      p3t: "Données synchronisées", p3: "Vos clients, chantiers et employés partagés en temps réel.",
      p4t: "Accès par forfait", p4: "Modules débloqués automatiquement selon votre abonnement.",
    },
    showcase: {
      eyebrow: "Aperçu de la plateforme",
      titleA: "Votre poste de commande,", titleB: "clair et puissant",
      desc: "Une interface sombre, premium et pensée pour le terrain. Tout ce dont votre entreprise a besoin, réuni dans un seul écran.",
      p1t: "Tableau de bord centralisé", p1: "Vos stats, modules et équipe d'un seul coup d'œil.",
      p2t: "Accès rapide aux modules", p2: "Lancez PUNCH, CRM, ERP, COMPTA ou DEVIS AI en un clic.",
      p3t: "Activité en temps réel", p3: "Suivez connexions, contrats et accès au fil de l'eau.",
      p4t: "Sur tous vos appareils", p4: "Bureau, tablette et mobile — partout sur le chantier.",
      cta: "Accéder à mon espace",
    },
    pricing: {
      eyebrow: "Tarification", titleA: "Payez seulement", titleB: "les modules", titleC: "qu'il vous faut",
      desc: "Chaque module PROGÈRE est offert seul. Combinez-en plusieurs et profitez automatiquement d'un rabais mensuel — plus vous connectez d'outils, plus vous économisez.",
      badge: "Rabais multi-modules automatique",
      save: "Économisez jusqu'à", saveEnd: "en connectant vos modules",
      li1: "5 modules · 3 paliers chacun", li2: "Options intégrées : PAIE (COMPTA) · TAKEOFF (ERP/DEVIS AI)", li3: "PROGÈRE SUPPORT inclus dans tous les forfaits",
      seeAll: "Voir la tarification",
      s1: "1 module", s2: "2 modules", s3: "3 modules", s4: "4 modules +",
      base: "Prix de base", discount: "Rabais", discountMax: "Rabais max",
      foot: "Le rabais s'applique automatiquement selon le nombre de modules choisis. Prix en CAD — taxes (TPS/TVQ) affichées avant le paiement.",
    },
    footer: {
      tagline: "INNOVER. CONSTRUIRE. PROGÉRER.", sub: "Solutions intelligentes pour la construction.",
      modules: "Modules", ecosystem: "Écosystème", account: "Compte",
      seeModules: "Voir les modules", plans: "Forfaits & abonnements", ecoCentral: "Écosystème centralisé", demo: "Demander une démo",
      login: "Connexion", register: "Créer un compte", dashboard: "Tableau de bord",
      privacy: "Confidentialité (Loi 25)", terms: "Conditions", notice: "Mentions légales", connect: "Se connecter",
      rights: "Tous droits réservés.",
    },
    cookie: {
      text1: "Nous utilisons des", cookies: "témoins (cookies)",
      text2: "essentiels au fonctionnement (session, sécurité) et, avec votre accord, des témoins optionnels (préférences, mesure d'audience), conformément à la",
      loi: "Loi 25 (Québec)", policy: "Politique de confidentialité et des témoins",
      refuse: "Refuser les témoins optionnels", accept: "Tout accepter",
    },
    common: { ecosystem: "Écosystème d'entreprise" },
    moduleData: {
      punch: { tagline: "Gestion du temps & chantier", description: "Gestion du temps, feuilles de temps, géolocalisation, chantier, rapports CCQ." },
      crm: { tagline: "Clients & ventes", description: "Gestion clients, pipeline, suivis, ventes, soumissions, relances." },
      erp: { tagline: "Projets & ressources", description: "Gestion de projets, documents, échéanciers, achats, inventaire, ressources." },
      compta: { tagline: "Comptabilité & paie", description: "Comptabilité, facturation, dépenses, paie, CCQ, rapports financiers." },
      "devis-ai": { tagline: "Estimation intelligente", description: "Estimation et création de devis assistées par intelligence artificielle." },
      support: { tagline: "Aide & assistance", description: "Centre d'aide, billets de support, documentation, assistance client." },
    },
    calc: {
      title: "Calculez votre abonnement PROGÈRE",
      subtitle: "Choisissez un palier différent pour chaque module et voyez votre rabais automatique.",
      construction: "En construction", soon: "Bientôt disponible — non achetable pour l'instant.",
      option: "Option", paieNote: "PROGÈRE PAIE est disponible seulement avec PROGÈRE COMPTA et suit son palier.",
      takeoffNote: "PROGÈRE TAKEOFF est disponible seulement avec PROGÈRE DEVIS AI.",
      selection: "Votre sélection", none: "Aucun module sélectionné.", optionTag: "(option)",
      regular: "Prix régulier", multiDiscount: "Rabais multi-modules", saving: "Votre économie", total: "Total mensuel",
      perMonth: "/mois",
      nudge0: "Sélectionnez 2 modules pour débloquer −10 % automatiquement.",
      nudgeAdd: "Ajoutez", module: "module", modules: "modules", nudgeTo: "de plus pour passer à",
      disclaimer: "Prix en dollars canadiens (CAD). Les taxes applicables (TPS/TVQ) sont calculées et affichées avant le paiement dans Stripe Checkout.",
      pay: "Continuer vers le paiement sécurisé", redirecting: "Redirection vers Stripe…",
      payNote: "Le total final sera confirmé dans Stripe Checkout avant le paiement.",
      selectOne: "Sélectionnez au moins un module.", loginFirst: "Connectez-vous pour finaliser votre abonnement.",
      payError: "Impossible de démarrer le paiement.",
    },
    demo: {
      eyebrow: "Connexion", titleA: "Rejoignez", titleB: "l'écosystème",
      desc: "Créez votre compte, connectez-vous, ou testez la plateforme en mode démo. Les permissions s'adaptent à votre abonnement.",
      loginT: "Connexion utilisateur", loginS: "Accédez à votre tableau de bord central",
      registerT: "Création de compte", registerS: "Enregistrez votre entreprise en 1 minute",
      demoT: "Accès démo", demoS: "admin@progere.ca — écosystème complet",
      formTitle: "Demander une démo", formSub: "Notre équipe vous présente l'écosystème complet.",
      name: "Nom complet", email: "Courriel professionnel", company: "Entreprise", phone: "Téléphone",
      message: "Votre besoin (optionnel)", send: "Envoyer la demande", sending: "Envoi...",
      sent: "Demande envoyée !", sendError: "Erreur lors de l'envoi",
    },
    auth: {
      brandA: "Le centre de contrôle de votre ", brandB: "écosystème d'entreprise",
      brandDesc: "Une seule connexion pour piloter PUNCH, CRM, ERP, COMPTA, DEVIS AI et SUPPORT.",
      back: "Retour",
      loginTitle: "Connexion", loginSubtitle: "Accédez à votre espace PROGÈRE.",
      noAccount: "Pas encore de compte ?", createAccount: "Créer un compte",
      email: "Courriel", emailPh: "vous@entreprise.ca", password: "Mot de passe",
      loginSubmit: "Se connecter", loginSubmitting: "Connexion...", useDemo: "Utiliser le compte démo",
      welcome: "Bienvenue, {name}", loginError: "Connexion impossible",
      forgotLink: "Mot de passe oublié ?",
      tryDemo: "Essayer la démo instantanée",
      tryDemoLoading: "Création de votre démo...",
      tryDemoError: "Impossible de démarrer la démo. Réessayez.",
      forgotTitle: "Mot de passe oublié", forgotSubtitle: "Entrez votre courriel, on vous envoie un lien de réinitialisation.",
      forgotSubmit: "Envoyer le lien", forgotSubmitting: "Envoi...",
      forgotSent: "Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte courriel.",
      backToLogin: "← Retour à la connexion",
      resetTitle: "Nouveau mot de passe", resetSubtitle: "Choisissez un nouveau mot de passe sécurisé.",
      newPassword: "Nouveau mot de passe", confirmPassword: "Confirmer le mot de passe",
      resetSubmit: "Mettre à jour le mot de passe", resetSubmitting: "Mise à jour...",
      resetDone: "Mot de passe mis à jour ! Redirection vers la connexion...",
      passwordMismatch: "Les mots de passe ne correspondent pas.",
      resetInvalid: "Lien de réinitialisation invalide ou expiré.",
      resetNoToken: "Lien invalide : aucun jeton fourni.",
      registerTitle: "Créer un compte", registerSubtitle: "Enregistrez votre entreprise et démarrez avec le forfait de base.",
      haveAccount: "Déjà un compte ?", loginLink: "Se connecter",
      name: "Nom complet", namePh: "Jean Tremblay", company: "Entreprise", companyPh: "Construction ABC inc.",
      passwordPh: "Min. 6 caractères", signature: "Signature électronique", signaturePh: "Tapez votre nom complet pour signer",
      consentA: "J'ai lu et j'accepte les ", terms: "Conditions d'utilisation", consentAnd: " et la ",
      privacy: "Politique de confidentialité (Loi 25)", consentEnd: ". Ma signature électronique vaut engagement contractuel.",
      consentRequired: "Vous devez lire et accepter les conditions et la politique de confidentialité (Loi 25).",
      registerSubmit: "Créer mon compte", registerSubmitting: "Création...",
      created: "Compte créé — bienvenue, {name}", registerError: "Inscription impossible",
    },
    pricingPage: {
      subtitle: "Le centre de contrôle de votre entreprise",
      ourModules: "Nos modules", clickA: "Cliquez sur un module pour voir ses", plans: "forfaits",
      hide: "Masquer", seePlans: "Voir les forfaits",
      includedAll: "Inclus dans tous les forfaits", talkTech: "Parler à un technicien",
      fullEco: "Écosystème complet", onDemand: "Sur demande", requestQuote: "Demander une soumission",
      included: "Inclus", benefits: "Avantages",
      stripeNote: "Tous les paiements passent par un seul compte Stripe. Chaque abonnement active uniquement le module payé. À l'achat : lecture et signature du contrat, activation immédiate, contrat archivé et envoyé par courriel.",
      savings: "Économies", saveA: "Économisez en combinant plusieurs", modules: "modules",
      saveDesc: "Plus votre entreprise connecte ses outils PROGÈRE, plus votre gestion devient efficace. Choisissez 2, 3 ou 4 modules selon vos besoins et profitez automatiquement d'un rabais mensuel, sans devoir passer au forfait PROGÈRE 360.",
      tblCount: "Nombre de modules", tblDiscount: "Rabais", tblExample: "Exemple",
      priceExamples: "Exemples de prix avec rabais",
      regular: "Prix régulier", discount: "Rabais", saving: "Économie", final: "Prix final",
      supportDesc: "Parlez directement à l'un de nos techniciens ou à l'assistant IA, posez toutes vos questions et suivez vos demandes — sans frais additionnels.",
    },
    plancard: {
      popular: "Populaire", perMonth: "CAD/mois",
      chooseStarter: "Choisir Starter", choosePro: "Choisir Pro", chooseEnterprise: "Choisir Entreprise",
      add: "Ajouter à l'abonnement :", constructionCta: "En construction — bientôt disponible",
    },
    md: {
      allModules: "Tous les modules", premium: "Premium",
      constructionNoticeA: "Ce module est actuellement", constructionNoticeB: "en construction",
      constructionNoticeC: "et sera disponible prochainement. Vous pouvez déjà réserver votre forfait.",
      seePlansPrices: "Voir les forfaits & prix", openModule: "Accéder au module",
      featuresA: "Fonctionnalités", featuresB: "clés", forWho: "Pour qui ?",
      pricing: "Tarification", unlock: "Débloquez", plansDesc: "Choisissez le palier qui vous convient. Mêmes prix et options que sur la page de tarification.",
      seeAllPricing: "Voir toute la tarification & rabais multi-modules",
      purchaseNote: "À l'achat : lecture et signature du contrat, activation immédiate du module, contrat envoyé par courriel et archivé.",
    },
    dash: {
      nav: { dashboard: "Tableau de bord", modules: "Modules", activity: "Journal d'activité", notifications: "Notifications", team: "Équipe", support: "Support", settings: "Paramètres", billing: "Facturation", mediakit: "Kit média" },
      plan: { base: "Module de base", pro: "Module professionnel", entreprise: "Module entreprise", ecosysteme: "Écosystème complet" },
      settings: "Paramètres", logout: "Déconnexion",
      greeting: "Bonjour", state: "Voici l'état de votre écosystème — forfait",
      activeModules: "Modules actifs", premiumModules: "Modules premium", members: "Membres", events: "Événements",
      quickAccess: "Accès rapide aux modules", seeAll: "Tout voir", noModules: "Aucun module actif. Mettez à niveau votre forfait.",
      recentActivity: "Activité récente", noActivity: "Aucune activité.",
      pages: {
        modules: {
          title: "Modules",
          desc: "Accédez à vos modules via connexion unique (SSO). Les modules verrouillés nécessitent un forfait supérieur.",
          locked: "verrouillé", soon: "Bientôt disponible", lockedBtn: "Verrouillé",
          open: "Ouvrir", opening: "Ouverture...", higher: "Disponible avec un forfait supérieur",
          unlock: "Débloquer ce module", unlockHint: "Paiement requis — choisissez un forfait pour débloquer.",
          tNotIncluded: "Ce module n'est pas inclus dans votre abonnement actuel.",
          tNotInPlan: "Ce module n'est pas inclus dans votre forfait.",
          tCantVerify: "Impossible de vérifier l'accès.",
          tCantOpen: "Impossible d'ouvrir le module",
          tOpened: "Ouverture de {name} avec connexion unique (SSO)",
        },
        activity: { title: "Journal d'activité", desc: "Historique des actions dans votre écosystème.", empty: "Aucune activité enregistrée.", by: "par" },
        notif: { title: "Centre de notifications", desc: "Vos alertes et mises à jour de l'écosystème.", empty: "Aucune notification.", markRead: "Marquer lu" },
        team: {
          title: "Équipe & permissions", desc: "Gérez les utilisateurs de votre entreprise, leurs rôles et leurs accès.",
          roles: { owner: "Propriétaire", admin: "Administrateur", manager: "Gestionnaire", member: "Membre" },
          members: "Membres", invite: "Inviter un membre", inviteDesc: "Envoyez une invitation par courriel pour rejoindre votre entreprise.",
          name: "Nom", email: "Courriel", role: "Rôle", send: "Envoyer l'invitation", sending: "Envoi…",
          invited: "Invitation envoyée", inviteErr: "Impossible d'envoyer l'invitation",
          emailSentYes: "Un courriel d'invitation a été envoyé.", emailSentNo: "Courriel non configuré — copiez le lien ci-dessous :",
          copyLink: "Copier le lien", copied: "Lien copié",
          pending: "Invitations en attente", noPending: "Aucune invitation en attente.", expired: "Expirée", revoke: "Révoquer", revoked: "Invitation révoquée",
          you: "Vous", remove: "Retirer", removed: "Membre retiré", roleUpdated: "Rôle mis à jour",
          confirmRemove: "Retirer ce membre de l'entreprise ?", manageHint: "Seuls le propriétaire et les administrateurs peuvent gérer l'équipe.",
        },
        tickets: { title: "Billets de support", desc: "Suivez et gérez vos demandes d'assistance.", openCenter: "Ouvrir le centre d'aide", empty: "Aucun billet pour le moment.", openTicket: "Ouvrir un billet →", updated: "Statut mis à jour", statuses: { "ouvert": "ouvert", "en cours": "en cours", "résolu": "résolu" }, prio: { basse: "basse", normale: "normale", haute: "haute", urgente: "urgente" } },
        settings: {
          title: "Paramètres globaux", desc: "Gérez votre entreprise et votre abonnement.",
          company: "Profil de l'entreprise", companyName: "Nom commercial", legalName: "Raison sociale (légale)",
          save: "Enregistrer", saving: "...", savedName: "Paramètres de l'entreprise mis à jour",
          logo: "Logo de l'entreprise", logoHint: "PNG, JPG ou SVG — 2 Mo max.", uploadLogo: "Téléverser un logo", removeLogo: "Retirer", logoTooBig: "Image trop volumineuse (2 Mo max).",
          taxes: "Taxes (Québec)", gst: "Numéro de TPS", qst: "Numéro de TVQ",
          contact: "Coordonnées", address: "Adresse", phone: "Téléphone", website: "Site web",
          planTitle: "Abonnement & accès aux modules", planDesc: "Changez de forfait pour débloquer plus de modules.",
          active: "Actif", current: "Forfait actuel", choose: "Choisir ce forfait", custom: "Sur mesure", perMonth: "/mois",
          changed: "Forfait mis à jour — modules ajustés",
          stripeNote: "Le paiement Stripe sera activé prochainement. Le changement de forfait est immédiat pour la démo.",
        },
        acceptInvite: {
          title: "Rejoindre", subtitle: "Créez votre mot de passe pour activer votre accès à",
          name: "Votre nom", email: "Courriel", password: "Mot de passe", confirm: "Confirmer le mot de passe",
          role: "Rôle", submit: "Activer mon compte", submitting: "Activation…",
          mismatch: "Les mots de passe ne correspondent pas.", success: "Compte activé — bienvenue !",
          invalid: "Invitation invalide ou expirée.", backHome: "Retour à l'accueil",
        },
      },
    },
  },
  en: {
    nav: { modules: "Modules", pricing: "Pricing", ecosystem: "Ecosystem", plans: "Plans", demo: "Demo", space: "Go to my workspace", mySpace: "My workspace" },
    hero: {
      badge: "Official portal",
      title2a: "Your entire construction business,",
      title2b: "run from one place.",
      desc: "Time tracking, CRM, projects, accounting, AI quotes — no more scattered software. PROGÈRE connects your job sites, teams and back-office in one smart ecosystem, built for Quebec.",
      ctaSpace: "Go to my workspace",
      ctaModules: "See the modules",
      ctaDemo: "Request a demo",
      stat1: "Connected modules", stat2: "Single sign-on (SSO)", stat3: "Users (Enterprise)",
    },
    trust: {
      loi25: "Law 25 compliant", loi25s: "Data protection (QC)",
      tax: "GST / QST", taxs: "Quebec taxes built in",
      canada: "Hosted in Canada", canadas: "Data on Canadian soil",
      support: "Support in French", supports: "A local team, included",
    },
    ba: {
      eyebrow: "The problem → the solution",
      titleA: "Stop juggling", titleB: "6 separate tools",
      desc: "One brain for the whole job site. PROGÈRE brings together what used to be scattered into a system where everything talks to each other.",
      before: "Before", withP: "With",
      chaos: ["Payroll Excel", "Quote emails", "Punch-in app", "Paper sheets", "Lost files", "Printouts"],
      beforeText: "Scattered data, double entry, lost information. Your teams waste time re-typing instead of building.",
      afterText: "One login, one database. Your job sites, clients, employees and finances synced in real time.",
      cta: "Build my system",
    },
    modules: {
      eyebrow: "The ecosystem", titleA: "All your modules,", titleB: "one single portal",
      desc: "Each PROGÈRE module is specialized and perfectly connected to the central portal. Click to access it directly.",
      discover: "Discover & see pricing", supportCta: "Need support? Click here",
    },
    eco: {
      eyebrow: "Centralized ecosystem", titleA: "Everything connects to",
      desc: "PROGÈRE is the master application. It centralizes your companies, users, roles and permissions — and plugs every module of the ecosystem into one coherent platform.",
      p1t: "Central API", p1: "All modules communicate through the central PROGÈRE API.",
      p2t: "Single Sign-On", p2: "One login to access the entire ecosystem.",
      p3t: "Synced data", p3: "Your clients, job sites and employees shared in real time.",
      p4t: "Access by plan", p4: "Modules unlocked automatically based on your subscription.",
    },
    showcase: {
      eyebrow: "Platform preview",
      titleA: "Your command center,", titleB: "clear and powerful",
      desc: "A dark, premium interface designed for the field. Everything your business needs, on a single screen.",
      p1t: "Centralized dashboard", p1: "Your stats, modules and team at a glance.",
      p2t: "Quick module access", p2: "Launch PUNCH, CRM, ERP, COMPTA or DEVIS AI in one click.",
      p3t: "Real-time activity", p3: "Track logins, contracts and access as they happen.",
      p4t: "On all your devices", p4: "Desktop, tablet and mobile — everywhere on site.",
      cta: "Go to my workspace",
    },
    pricing: {
      eyebrow: "Pricing", titleA: "Pay only for", titleB: "the modules", titleC: "you need",
      desc: "Every PROGÈRE module is available on its own. Combine several and automatically enjoy a monthly discount — the more tools you connect, the more you save.",
      badge: "Automatic multi-module discount",
      save: "Save up to", saveEnd: "by connecting your modules",
      li1: "5 modules · 3 tiers each", li2: "Built-in options: PAYROLL (COMPTA) · TAKEOFF (ERP/DEVIS AI)", li3: "PROGÈRE SUPPORT included in every plan",
      seeAll: "See pricing",
      s1: "1 module", s2: "2 modules", s3: "3 modules", s4: "4 modules +",
      base: "Base price", discount: "Discount", discountMax: "Max discount",
      foot: "The discount applies automatically based on the number of modules selected. Prices in CAD — taxes (GST/QST) shown before payment.",
    },
    footer: {
      tagline: "INNOVATE. BUILD. MANAGE.", sub: "Smart solutions for construction.",
      modules: "Modules", ecosystem: "Ecosystem", account: "Account",
      seeModules: "See the modules", plans: "Plans & subscriptions", ecoCentral: "Centralized ecosystem", demo: "Request a demo",
      login: "Log in", register: "Create an account", dashboard: "Dashboard",
      privacy: "Privacy (Law 25)", terms: "Terms", notice: "Legal notice", connect: "Log in",
      rights: "All rights reserved.",
    },
    cookie: {
      text1: "We use", cookies: "cookies",
      text2: "essential to operation (session, security) and, with your consent, optional cookies (preferences, analytics), in accordance with",
      loi: "Law 25 (Quebec)", policy: "Privacy and cookie policy",
      refuse: "Refuse optional cookies", accept: "Accept all",
    },
    common: { ecosystem: "Enterprise ecosystem" },
    moduleData: {
      punch: { tagline: "Time & job site management", description: "Time tracking, timesheets, geolocation, job site, CCQ reports." },
      crm: { tagline: "Clients & sales", description: "Client management, pipeline, follow-ups, sales, quotes, reminders." },
      erp: { tagline: "Projects & resources", description: "Project management, documents, schedules, purchasing, inventory, resources." },
      compta: { tagline: "Accounting & payroll", description: "Accounting, invoicing, expenses, payroll, CCQ, financial reports." },
      "devis-ai": { tagline: "Smart estimating", description: "AI-assisted estimating and quote creation." },
      support: { tagline: "Help & assistance", description: "Help center, support tickets, documentation, customer assistance." },
    },
    calc: {
      title: "Calculate your PROGÈRE subscription",
      subtitle: "Pick a different tier for each module and see your automatic discount.",
      construction: "Under construction", soon: "Coming soon — not available for purchase yet.",
      option: "Option", paieNote: "PROGÈRE PAYROLL is available only with PROGÈRE COMPTA and follows its tier.",
      takeoffNote: "PROGÈRE TAKEOFF is available only with PROGÈRE DEVIS AI.",
      selection: "Your selection", none: "No module selected.", optionTag: "(option)",
      regular: "Regular price", multiDiscount: "Multi-module discount", saving: "Your savings", total: "Monthly total",
      perMonth: "/mo",
      nudge0: "Select 2 modules to unlock −10 % automatically.",
      nudgeAdd: "Add", module: "more module", modules: "more modules", nudgeTo: "to unlock",
      disclaimer: "Prices in Canadian dollars (CAD). Applicable taxes (GST/QST) are calculated and shown before payment in Stripe Checkout.",
      pay: "Continue to secure payment", redirecting: "Redirecting to Stripe…",
      payNote: "The final total will be confirmed in Stripe Checkout before payment.",
      selectOne: "Select at least one module.", loginFirst: "Log in to finalize your subscription.",
      payError: "Unable to start payment.",
    },
    demo: {
      eyebrow: "Sign in", titleA: "Join", titleB: "the ecosystem",
      desc: "Create your account, log in, or try the platform in demo mode. Permissions adapt to your subscription.",
      loginT: "User login", loginS: "Access your central dashboard",
      registerT: "Create an account", registerS: "Register your company in 1 minute",
      demoT: "Demo access", demoS: "admin@progere.ca — full ecosystem",
      formTitle: "Request a demo", formSub: "Our team will walk you through the full ecosystem.",
      name: "Full name", email: "Work email", company: "Company", phone: "Phone",
      message: "Your needs (optional)", send: "Send request", sending: "Sending...",
      sent: "Request sent!", sendError: "Error while sending",
    },
    auth: {
      brandA: "The control center of your ", brandB: "enterprise ecosystem",
      brandDesc: "One login to run PUNCH, CRM, ERP, COMPTA, DEVIS AI and SUPPORT.",
      back: "Back",
      loginTitle: "Log in", loginSubtitle: "Access your PROGÈRE workspace.",
      noAccount: "No account yet?", createAccount: "Create an account",
      email: "Email", emailPh: "you@company.ca", password: "Password",
      loginSubmit: "Log in", loginSubmitting: "Logging in...", useDemo: "Use the demo account",
      welcome: "Welcome, {name}", loginError: "Unable to log in",
      forgotLink: "Forgot password?",
      tryDemo: "Try the instant demo",
      tryDemoLoading: "Creating your demo...",
      tryDemoError: "Couldn't start the demo. Please try again.",
      forgotTitle: "Forgot password", forgotSubtitle: "Enter your email and we'll send you a reset link.",
      forgotSubmit: "Send the link", forgotSubmitting: "Sending...",
      forgotSent: "If an account exists for this email, a reset link has just been sent. Check your inbox.",
      backToLogin: "← Back to login",
      resetTitle: "New password", resetSubtitle: "Choose a new secure password.",
      newPassword: "New password", confirmPassword: "Confirm password",
      resetSubmit: "Update password", resetSubmitting: "Updating...",
      resetDone: "Password updated! Redirecting to login...",
      passwordMismatch: "Passwords do not match.",
      resetInvalid: "Invalid or expired reset link.",
      resetNoToken: "Invalid link: no token provided.",
      registerTitle: "Create an account", registerSubtitle: "Register your company and start with the base plan.",
      haveAccount: "Already have an account?", loginLink: "Log in",
      name: "Full name", namePh: "John Smith", company: "Company", companyPh: "ABC Construction Inc.",
      passwordPh: "Min. 6 characters", signature: "Electronic signature", signaturePh: "Type your full name to sign",
      consentA: "I have read and accept the ", terms: "Terms of Use", consentAnd: " and the ",
      privacy: "Privacy Policy (Law 25)", consentEnd: ". My electronic signature constitutes a contractual commitment.",
      consentRequired: "You must read and accept the terms and privacy policy (Law 25).",
      registerSubmit: "Create my account", registerSubmitting: "Creating...",
      created: "Account created — welcome, {name}", registerError: "Unable to register",
    },
    pricingPage: {
      subtitle: "The control center of your business",
      ourModules: "Our modules", clickA: "Click a module to see its", plans: "plans",
      hide: "Hide", seePlans: "See plans",
      includedAll: "Included in every plan", talkTech: "Talk to a technician",
      fullEco: "Full ecosystem", onDemand: "On request", requestQuote: "Request a quote",
      included: "Included", benefits: "Benefits",
      stripeNote: "All payments go through a single Stripe account. Each subscription activates only the module paid for. On purchase: read and sign the contract, immediate activation, contract archived and emailed.",
      savings: "Savings", saveA: "Save by combining multiple", modules: "modules",
      saveDesc: "The more PROGÈRE tools your business connects, the more efficient your management becomes. Choose 2, 3 or 4 modules based on your needs and automatically enjoy a monthly discount, without upgrading to the PROGÈRE 360 plan.",
      tblCount: "Number of modules", tblDiscount: "Discount", tblExample: "Example",
      priceExamples: "Pricing examples with discount",
      regular: "Regular price", discount: "Discount", saving: "Savings", final: "Final price",
      supportDesc: "Talk directly to one of our technicians or the AI assistant, ask all your questions and track your requests — at no additional cost.",
    },
    plancard: {
      popular: "Popular", perMonth: "CAD/mo",
      chooseStarter: "Choose Starter", choosePro: "Choose Pro", chooseEnterprise: "Choose Enterprise",
      add: "Add to subscription:", constructionCta: "Under construction — coming soon",
    },
    md: {
      allModules: "All modules", premium: "Premium",
      constructionNoticeA: "This module is currently", constructionNoticeB: "under construction",
      constructionNoticeC: "and will be available soon. You can already reserve your plan.",
      seePlansPrices: "See plans & pricing", openModule: "Open the module",
      featuresA: "Key", featuresB: "features", forWho: "Who is it for?",
      pricing: "Pricing", unlock: "Unlock", plansDesc: "Choose the tier that suits you. Same prices and options as on the pricing page.",
      seeAllPricing: "See full pricing & multi-module discounts",
      purchaseNote: "On purchase: read and sign the contract, immediate module activation, contract emailed and archived.",
    },
    dash: {
      nav: { dashboard: "Dashboard", modules: "Modules", activity: "Activity log", notifications: "Notifications", team: "Team", support: "Support", settings: "Settings", billing: "Billing", mediakit: "Media kit" },
      plan: { base: "Base module", pro: "Professional module", entreprise: "Enterprise module", ecosysteme: "Full ecosystem" },
      settings: "Settings", logout: "Log out",
      greeting: "Hello", state: "Here is the state of your ecosystem — plan",
      activeModules: "Active modules", premiumModules: "Premium modules", members: "Members", events: "Events",
      quickAccess: "Quick access to modules", seeAll: "See all", noModules: "No active module. Upgrade your plan.",
      recentActivity: "Recent activity", noActivity: "No activity.",
      pages: {
        modules: {
          title: "Modules",
          desc: "Access your modules through single sign-on (SSO). Locked modules require a higher plan.",
          locked: "locked", soon: "Coming soon", lockedBtn: "Locked",
          open: "Open", opening: "Opening...", higher: "Available with a higher plan",
          unlock: "Unlock this module", unlockHint: "Payment required — choose a plan to unlock.",
          tNotIncluded: "This module is not included in your current subscription.",
          tNotInPlan: "This module is not included in your plan.",
          tCantVerify: "Unable to verify access.",
          tCantOpen: "Unable to open the module",
          tOpened: "Opening {name} with single sign-on (SSO)",
        },
        activity: { title: "Activity log", desc: "History of actions in your ecosystem.", empty: "No activity recorded.", by: "by" },
        notif: { title: "Notification center", desc: "Your ecosystem alerts and updates.", empty: "No notifications.", markRead: "Mark read" },
        team: {
          title: "Team & permissions", desc: "Manage your company users, their roles and access.",
          roles: { owner: "Owner", admin: "Administrator", manager: "Manager", member: "Member" },
          members: "Members", invite: "Invite a member", inviteDesc: "Send an email invitation to join your company.",
          name: "Name", email: "Email", role: "Role", send: "Send invitation", sending: "Sending…",
          invited: "Invitation sent", inviteErr: "Could not send invitation",
          emailSentYes: "An invitation email was sent.", emailSentNo: "Email not configured — copy the link below:",
          copyLink: "Copy link", copied: "Link copied",
          pending: "Pending invitations", noPending: "No pending invitations.", expired: "Expired", revoke: "Revoke", revoked: "Invitation revoked",
          you: "You", remove: "Remove", removed: "Member removed", roleUpdated: "Role updated",
          confirmRemove: "Remove this member from the company?", manageHint: "Only the owner and admins can manage the team.",
        },
        tickets: { title: "Support tickets", desc: "Track and manage your support requests.", openCenter: "Open the help center", empty: "No tickets yet.", openTicket: "Open a ticket →", updated: "Status updated", statuses: { "ouvert": "open", "en cours": "in progress", "résolu": "resolved" }, prio: { basse: "low", normale: "normal", haute: "high", urgente: "urgent" } },
        settings: {
          title: "Global settings", desc: "Manage your company and subscription.",
          company: "Company profile", companyName: "Business name", legalName: "Legal (registered) name",
          save: "Save", saving: "...", savedName: "Company settings updated",
          logo: "Company logo", logoHint: "PNG, JPG or SVG — 2 MB max.", uploadLogo: "Upload a logo", removeLogo: "Remove", logoTooBig: "Image too large (2 MB max).",
          taxes: "Taxes (Quebec)", gst: "GST number", qst: "QST number",
          contact: "Contact", address: "Address", phone: "Phone", website: "Website",
          planTitle: "Subscription & module access", planDesc: "Change your plan to unlock more modules.",
          active: "Active", current: "Current plan", choose: "Choose this plan", custom: "Custom", perMonth: "/mo",
          changed: "Plan updated — modules adjusted",
          stripeNote: "Stripe payment will be enabled soon. Plan change is immediate for the demo.",
        },
        acceptInvite: {
          title: "Join", subtitle: "Create your password to activate your access to",
          name: "Your name", email: "Email", password: "Password", confirm: "Confirm password",
          role: "Role", submit: "Activate my account", submitting: "Activating…",
          mismatch: "Passwords do not match.", success: "Account activated — welcome!",
          invalid: "Invalid or expired invitation.", backHome: "Back to home",
        },
      },
    },
  },
};
